import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import Navigation from './Navigation';
import favicon from '../assets/logo/favicon.png';

function Header() {
  // Page setup information
  const location = useLocation();

  // Manage the state of the hamburger menu. Only shows for mobile users 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); 
  const [isClosing, setIsClosing] = useState(false);
  const [menuOpenedBy, setMenuOpenedBy] = useState(null); // 'hover' or 'click'

  /**
   * Handle changing pages via the hamburger menu.
   * 
   * @param {*} page 
   */
  const handlePageChange = (page) => {
    // Go to top of home page if on home page
    if (page == '') {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    closeMobileMenu();
  };

  /**
   * Open the hamburger menu on hover.
   */
  const openMenu = () => {
    if (!isMobileMenuOpen) {
      setIsMobileMenuOpen(true);
      setIsClosing(false);
      setMenuOpenedBy('hover');
    }
  };

  /**
   * Close the hamburger menu on hover leave.
   */
  const closeMenu = () => {
    // Make sure opened on hover
    if (menuOpenedBy === 'hover') {
      if (isMobileMenuOpen) {
        setIsClosing(true);

        // Add a small delay to make sure other events, such as clicks and page changes,
        // doesn't affect menu behaviour; especially due to the hover.
        setTimeout(() => {
          setIsMobileMenuOpen(false);
          setIsClosing(false);
        }, 300);
      }

      setMenuOpenedBy(null);
    }
  };

  /**
   * Toggle hamburger menu open/close.
   * 
   * @returns 
   */
  const toggleMobileMenu = () => {
    // Block clicks if menu was opened onHover
    if (isMobileMenuOpen && menuOpenedBy === 'hover') {
      return;
    }
  
    if (isMobileMenuOpen) {
      // document.body.style.overflow = ""; // Re-enable scroll
      setIsClosing(true);
      setTimeout(() => {
        setIsMobileMenuOpen(false);
        setIsClosing(false);
        setMenuOpenedBy(null);
      }, 0);
    } else {
      // document.body.style.overflow = "hidden"; // Disable scroll
      setIsMobileMenuOpen(true);
      setIsClosing(false);
      setMenuOpenedBy('click');
    }
  };

  /**
   * Close the hamburger menu.
   */
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  /**
   * Extract the current page name from the URL.
   * 
   * @returns 
   */
  const getCurrentPageName = () => {
    const pathname = location.pathname;
    const currentPage = pathname.replace('/', '');
    return currentPage.charAt(0).toUpperCase() + currentPage.slice(1);
  };

  const activePage = getCurrentPageName();

  /**
   * Monitor when the esc key is pressed and close the menu.
   */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isMobileMenuOpen) {
        toggleMobileMenu();
      }
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isMobileMenuOpen]);

  /**
   * When changing pages, reset hamburger menu state management variables.
   */
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setMenuOpenedBy(null);
  }, [location.pathname]);

  return (
    <>
      <div className='header-background'></div>
      <div
        className="header"
        onClick={toggleMobileMenu}
        onMouseEnter={openMenu}
        onMouseLeave={closeMenu}
      >
        {/* Either (a) navigation bar for non-mobile users or (b) hamburger menu options for mobile users*/}
        <div className={isMobileMenuOpen ? `navigation-mobile ${isClosing ? 'closing' : ''}` : 'navigation-list'}>
          <Link
            to="/"
            onClick={() => handlePageChange('')}
          >
            <Navigation name="Home" className={activePage === '' ? 'yellow-active' : 'yellow-inactive'} />
          </Link>
          <Link
            to="/team"
            onClick={() => handlePageChange('About')}
          >
            <Navigation name="Team" className={activePage === 'Team' ? 'blue-active' : 'blue-inactive'} />
          </Link>
          <Link
            to="/projects"
            onClick={() => handlePageChange('Projects')}
          >
            <Navigation name="Projects" className={activePage === 'Projects' ? 'yellow-active' : 'yellow-inactive'} />
          </Link>
          <Link
            to="/#contact"  
            onClick={() => handlePageChange('Home')}
          >
            <Navigation name="Contact" className={activePage === 'Contact' ? 'yellow-active' : 'yellow-inactive'} />
          </Link>
          <Link
            to="/careers"  
            onClick={() => handlePageChange('Careers')}
          >
            <Navigation name="Crew Call" className={activePage === 'Careers' ? 'yellow-active' : 'yellow-inactive'} />
          </Link>
        </div>

        {/* Hamburger menu or close-hamburger-menu-x icon */}
        <div className='hamburgermenu'  >
          <img src={favicon} alt='final version 2 favicon' className='pulse-spin'/>
        </div>
      </div>
    </>
  );
}

export default Header;
